export const countryList = [
    { id: 1, country: "United States", flag: "united-states" },
    { id: 2, country: "Canada", flag: "canada" },
    { id: 3, country: "France", flag: "france" },
    { id: 4, country: "Netherlands", flag: "netherlands" },
    { id: 5, country: "Belgium", flag: "belgium" },
    { id: 6, country: "Italy", flag: "italy" },
    { id: 7, country: "Germany", flag: "germany" },
    { id: 8, country: "Indonesia", flag: "indonesia" },
    { id: 9, country: "+100 more", flag: "more" },
];